import urlJoin from "url-join";

export const wsmDealerSectionUrlName = "/wsm/dealer-pricing";

// Dealer groups are the section's list.
export const wsmDealerGroupListPath = `${wsmDealerSectionUrlName}/`;
export const wsmDealerGroupAddPath = urlJoin(wsmDealerGroupListPath, "add");
export const wsmDealerGroupPath = (id: string) => urlJoin(wsmDealerGroupListPath, id);
export const wsmDealerGroupUrl = (id: string) => wsmDealerGroupPath(encodeURIComponent(id));

// Customers: a thin assignment surface, not a second customer directory (D2).
// The stock Customers page keeps the dealer card. Matched before the group :id.
export const wsmDealerCustomerListPath = urlJoin(wsmDealerSectionUrlName, "customers") + "/";
export const wsmDealerCustomerAddPath = urlJoin(wsmDealerCustomerListPath, "add");
export const wsmDealerCustomerPath = (id: string) =>
  urlJoin(wsmDealerCustomerListPath, id);
export const wsmDealerCustomerUrl = (id: string) =>
  wsmDealerCustomerPath(encodeURIComponent(id));

export const wsmDealerSettingsPath = urlJoin(wsmDealerSectionUrlName, "settings");
